<template>
  <div class="col-12">
    <b-row
      v-for="(item, index) in generateItems"
      :key="index"
      align-v="center"
      class="my-2 bg-white border rounded py-2"
      :draggable="draggable"
      @dragover="draggable && onDragOver(item, index, $event)"
      @dragend="draggable && finishDrag(item, index, $event)"
      @dragstart="draggable && startDrag(item, $event)"
    >
      <b-col v-if="draggable" cols="auto" md="auto" class="d-md-none px-2">
        <b-button-group vertical>
          <b-button variant="success" size="sm" @click="moveUp(index)">
            <mdicon name="transfer-up" size="15" />
          </b-button>
          <b-button variant="danger" size="sm" @click="moveDown(index)">
            <mdicon name="transfer-down" size="15" />
          </b-button>
        </b-button-group>
      </b-col>
      <b-col
        v-if="draggable"
        md="1"
        cols="1"
        class="px-1 text-center d-none d-md-block"
      >
        <i class="fas fa-arrows-alt fa-lg" />
      </b-col>
      <b-col class="px-2">
        <slot name="body" :item="item" :index="index" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      over: {},
      dragFrom: {},
      startLoc: 0,
      dragging: false,
      generateItems: [],
    };
  },
  watch: {
    items(value) {
      if (value) {
        /* guidance: convert arrays to string and check is not equals it for don't loop */
        const itemsArr = value.toString();
        const generateArr = this.generateItems.toString();
        if (itemsArr !== generateArr) {
          this.generateItems = [...value];
          this.emitItems();
        }
      }
    },
  },
  methods: {
    startDrag(item, e) {
      this.startLoc = e.clientY;
      this.dragging = true;
      this.dragFrom = item;
    },
    finishDrag(item, pos) {
      this.generateItems.splice(pos, 1);
      this.generateItems.splice(this.over.pos, 0, item);
      this.over = {};
      this.$emit("getItems", this.generateItems);
    },
    onDragOver(item, pos, e) {
      const dir = this.startLoc < e.clientY ? "down" : "up";
      setTimeout(() => {
        this.over = {
          item,
          pos,
          dir,
        };
      }, 50);
    },
    emitItems() {
      this.$emit("getItems", this.generateItems);
    },
    moveUp(index) {
      if (index === 0) {
        // if its the first in the array
        this.generateItems.push(this.generateItems.shift()); // same as option 1
      } else {
        this.generateItems = this.generateItems.map((element, i) => {
          // iterate array and change places
          if (i === index - 1) {
            return this.generateItems[index];
          } else if (i === index) {
            return this.generateItems[index - 1];
          } else {
            return element;
          }
        });
      }
      this.emitItems();
    },
    moveDown(index) {
      if (index === this.generateItems.length - 1) {
        // if its the last in the array
        this.generateItems.unshift(this.generateItems.pop()); // same as option 1
      } else {
        this.generateItems = this.generateItems.map((element, i) => {
          // iterate array and change places
          if (i === index) {
            return this.generateItems[index + 1];
          } else if (i === index + 1) {
            return this.generateItems[index];
          } else {
            return element;
          }
        });
      }
      this.emitItems();
    },
  },
};
</script>

